import { action, observable, runInAction } from "mobx";
import { ApiResult, FieldType, ViewModelBase } from "@shoothill/core";

import { AppUrls } from "AppUrls";
import { ServerViewModel } from "Globals/ViewModels/ServerViewModel";
import { InductionAdminScaffoldingListItemModel, InductionAdminScaffoldInspectionListDTO } from "./InductionAdminScaffoldingListItemModel";

export class InductionAdminScaffoldingListViewModel extends ViewModelBase<any> {
    public server: ServerViewModel = new ServerViewModel();

    @observable
    public scaffoldingListModels = observable<InductionAdminScaffoldingListItemModel>([]);

    constructor(inductionUserId: string) {
        super();
        this.loadScaffoldList(inductionUserId);
    }

    // public GetList = async (projectId: string, date: Date): Promise<void> => {
    //     return this.server.query<ScaffoldInspectionListDTO>(
    //         () => this.Get(`${AppUrls.Server.Projects.Construction.ScaffoldInspection.GetProjectScaffoldList}?projectId=${projectId}&date=${date.toISOString()}`),
    //         (result) => {
    //             runInAction(() => {
    //                 //this.projectId = projectId;

    //                 const inspections: InductionAdminScaffoldingListItemModel[] = [];

    //                 for (const inspection of result.scaffoldInspectionList) {
    //                     const model = new InductionAdminScaffoldingListItemModel();

    //                     model.fromDto(inspection);

    //                     inspections.push(model);
    //                 }

    //                 this.scaffoldingListModels.replace(inspections);
    //             });
    //         },
    //     );
    // };

    public loadScaffoldList = async (id: string): Promise<ApiResult<InductionAdminScaffoldInspectionListDTO>> => {
        this.setIsLoading(true);
        //let paramsViewModel = AdminSiteAccessFilterViewModel.Instance;
        let params = { id: id };

        const apiResult = await this.Post<InductionAdminScaffoldInspectionListDTO>(AppUrls.Server.Induction.GetInductionScaffoldByInductionUserId, params);
        if (apiResult) {
            if (apiResult.wasSuccessful) {
                runInAction(() => {
                    //this.projectId = projectId;

                    const inspections: InductionAdminScaffoldingListItemModel[] = [];

                    for (const inspection of apiResult.payload.scaffoldInspectionList) {
                        const model = new InductionAdminScaffoldingListItemModel();

                        model.fromDto(inspection);

                        inspections.push(model);
                    }

                    this.scaffoldingListModels.replace(inspections);
                });
            } else {
                console.log(apiResult.errors);
            }
        }
        this.setIsLoading(false);
        return apiResult;
    };

    @action
    public navigateToScaffoldInspection = (model: InductionAdminScaffoldingListItemModel) => {
        this.history.push(AppUrls.Client.Project.Scaffolding.View.replace(":projectid", model.projectId).replace(":scaffoldingId", model.id));
    };

    // #region Bolierplate

    public async isFieldValid(fieldName: keyof FieldType<InductionAdminScaffoldingListItemModel>, value: any): Promise<boolean> {
        let { isValid, errorMessage } = await this.validateDecorators(fieldName);

        this.setError(fieldName, errorMessage);
        this.setValid(fieldName, isValid);

        return isValid;
    }

    public afterUpdate: undefined;
    public beforeUpdate: undefined;

    // #endregion Bolierplate
}
